export function getNoopAPI() {
    return {
        pushLog: () => { },
        pushError: () => { },
        changeStacktraceParser: () => { },
        getStacktraceParser: () => undefined,
        pushMeasurement: () => { },
        pushTraces: () => { },
        getOTEL: () => undefined,
        getTraceContext: () => undefined,
        initOTEL: () => { },
        isOTELInitialized: () => false,
        setUser: () => { },
        resetUser: () => { },
        setSession: () => { },
        resetSession: () => { },
        getSession: () => undefined,
        setView: () => { },
        getView: () => undefined,
        setPage: () => { },
        getPage: () => undefined,
        pushEvent: () => { },
        startUserAction: () => undefined,
        getActiveUserAction: () => undefined,
    };
}
//# sourceMappingURL=noop.js.map